<template>
  <div class="radiogroup" :class="{'radiogroup_withimages':images}">
    <div class="radiogroup__content" :class="{'radiogroup__content_grid':grid, 'radiogroup__content_grid-inc': grid && images && (images.length > 3 || inc), 'radiogroup__content_grid-inc-3': inc && images && images.length == 3, 'radiogroup__content_gridstay':gridstay}" role="radiogroup">
      <RadioInput :disabled="disabled" v-for="(v,i) in values" :key="v" v-model="val"  :name="name" :text="texts?texts[i]:v" :inputvalue="v" :required="required" :image="images?images[i]:''"/>
    </div>
  </div>
</template>

<script>
import RadioInput from './RadioInput.vue'
export default {
  components: {RadioInput},
  props: {
    grid: {type: Boolean, required: false, default: false},
    gridstay: {type: Boolean, required: false, default: false},
    inc: {type: Boolean, required: false, default: false},
    modelValue: {type: String},
    texts: {type: Array},
    values: {type: Array, required: true},
    images: {type: Array, required: false},
    name: {type: String, required: true},
    required: {type: Boolean},
    attrmode: {type: Boolean, default: false},
    disabled: { type: Boolean, default: false },
  },
  computed: {
    val:{
      get(){
        return this.modelValue
      },
      set(v){
        this.$emit('update:modelValue', v)
      },
    }
  },
  watch: {
    value(val, old){
      if (this.attrmode)
        this.$el.setAttribute('data-value', val)
      if (val != old)
        this.$emit('update:modelValue', val)
    }
  }

}
</script>

<style lang="sass">
.radiogroup
  margin-bottom: 32px
  &_withimages
    padding-top: 2px
    --gap: 80px
  &_slide2
    margin-bottom: 34px
    @include from(500px)
      width: 100%
      .radiogroup__content
        display: flex
        padding-left: 16px
        padding-right: 16px
        gap: 0
        grid-gap: 0
        justify-content: space-between
        .pfradio__image
          margin-bottom: 17px
        .pfradio__text
          margin-bottom: 11px


  --gap: 32px
  &__content
    
    &_grid
      display: grid
      grid-gap: var(--gap)
      gap: var(--gap)
      grid-template-columns: auto auto
      justify-content: start
      align-content: start
      &-inc
        grid-template-columns: auto auto auto auto
        @include for-mob
          gap: 24px
          grid-gap: 24px

      @include from(globalvars.$nano)
        &:not(.radiogroup__content_gridstay), &.radiogroup__content_grid-inc-3:nth-child(n)
          grid-template-columns: 1fr
        &.radiogroup__content_gridstay
          grid-template-columns: 1fr 1fr
          //gap: 24px
          //grid-gap: 24px
    &:not(&_grid) >*:not(:last-child)
      margin-bottom: 32px
    label
      display: flex

</style>